import React, {CSSProperties, ReactNode} from 'react';
import {formatMessageBundle} from '@unifocus/js-utils';
import {Button, ButtonType} from '../../controls/button';
import messages from '../../../localized-messages';
import classnames from 'classnames';

/**
 * The submit button for a Form.  This component
 * should be placed somewhere in the subtree of a
 * Form component.
 *
 * {@docCategory SubmitButton}
 */
export interface SubmitButtonProps {

   /**
    * Whether the button is disabled or not.
    *
    * @defaultvalue false
    */
   disabled?: boolean;

   /**
    * Sets the button type.
    * @defaultvalue primary
    */
   type?: ButtonType;

   /**
    * The name of the form that this submit button is associated with.  Setting this will help
    * with submitting the form using enter key.
    */
   formName?: string;

   /**
    * Content to be displayed in the Button's content area.
    */
   children?: ReactNode;

   /**
    * Sets a className.
    */
   className?: string;

   /**
    * Sets styles.
    */
   style?: CSSProperties;
}

export const SubmitButton = (props: SubmitButtonProps) => {

   return (
      <FormButton
         type={props.type || 'primary'}
         disabled={props.disabled}
         formName={props.formName}
         className={props.className}
         style={props.style}
      >
         {props.children}
      </FormButton>
   );
};

interface FormButtonProps {
   type: ButtonType;
   disabled?: boolean;
   formName?: string;
   children?: ReactNode;
   className?: string;
   style?: CSSProperties;
}

const FormButton = (props: FormButtonProps) => {
   return (
      <Button
         type={props.type}
         className={classnames('uf-submit-button', props.className)}
         disabled={props.disabled}
         form={props.formName}
         formButtonType={'submit'}
         style={props.style}
      >
         {props.children || formatMessageBundle(messages, 'res_submit')}
      </Button>
   );
};
